/**
 * @file
 *
 * Rented products behavior.
 */

(function(Drupal, once) {
  Drupal.behaviors.dxpPagination = {
    attach(context) {
      const serviceHistoryContainers = document.querySelectorAll(
        ".dxp-pagination"
      );
      serviceHistoryContainers.forEach(container => {
        const items = container.querySelectorAll(".dxp-pagination-item");
        const containerItemsPerPage = container.getAttribute(
          "data-items-per-page"
        );
        const itemsPerPage = containerItemsPerPage
          ? parseInt(containerItemsPerPage, 10)
          : 10;
        const totalPages = Math.ceil(items.length / itemsPerPage);

        if (totalPages <= 1) {
          // Add active class to all items if there's only one page
          items.forEach(item => {
            item.classList.add("active");
          });

          return; // No pagination needed
        }

        const pagination = document.createElement("nav");
        pagination.innerHTML = `
          <ul class="pagination pager__items js-pager__items justify-content-center">
            <li class="page-item pager__item pager__item--previous disabled">
              <a class="page-link" href="#" data-page="prev">
                <span class="visually-hidden">Previous</span>
                <span><i class="micon icomoon-arrow-left" aria-hidden="true"></i></span>
              </a>
            </li>
            ${Array.from(
              { length: totalPages },
              (_, i) => `
              <li class="page-item pager__item ${i === 0 ? "active" : ""}">
                <a class="page-link" href="#" data-page="${i + 1}">${i + 1}</a>
              </li>
            `
            ).join("")}
            <li class="page-item pager__item pager__item--next ${
              totalPages === 1 ? "disabled" : ""
            }">
              <a class="page-link" href="#" data-page="next">
                <span class="visually-hidden">Next</span>
                <span><i class="micon icomoon-arrow-right" aria-hidden="true"></i></span>
              </a>
            </li>
          </ul>
        `;
        container.parentElement.appendChild(pagination);

        const showPage = page => {
          // Update the visibility of items based on the current page
          items.forEach((item, index) => {
            const isVisible =
              index >= (page - 1) * itemsPerPage && index < page * itemsPerPage;
            item.style.display = isVisible ? "" : "none";
            item.classList.toggle("active", isVisible);
          });

          // Update pagination controls
          const pageItems = pagination.querySelectorAll(".page-item");
          pageItems.forEach((item, index) => {
            item.classList.remove("active", "disabled");
            item.style.display = "";
            if (index === page) {
              item.classList.add("active");
            }
          });

          // Disable "Previous" button if on the first page
          if (page === 1) {
            pageItems[0].classList.add("disabled");
            pageItems[0].style.display = "none";
          }

          // Disable "Next" button if on the last page
          if (page === totalPages) {
            pageItems[pageItems.length - 1].classList.add("disabled");
            pageItems[pageItems.length - 1].style.display = "none";
          }
        };

        pagination.addEventListener("click", event => {
          event.preventDefault();

          const target = event.target.closest(".page-link");
          if (!target) return;

          const currentPage = parseInt(
            pagination.querySelector(".page-item.active .page-link").dataset
              .page,
            10
          );

          let newPage;
          if (target.dataset.page === "prev") {
            newPage = currentPage - 1;
          } else if (target.dataset.page === "next") {
            newPage = currentPage + 1;
          } else {
            newPage = parseInt(target.dataset.page, 10);
          }

          if (newPage >= 1 && newPage <= totalPages) {
            showPage(newPage);
          }

          document.dispatchEvent(new Event("PaginationPageChanged"));
        });

        showPage(1);
      });
    }
  };
})(Drupal, once);
